module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-haircut-fr@2x-ea5055d89577e27354c9386be19b09f7.png";